import React, { Component } from 'react'
import moment from 'moment'

import Datepicker from './parts/Datepicker'
import Sports from './parts/Sports'
import Radius from './parts/Radius'
import Icon from './Icon'
import PublicStateChart from './parts/PublicStateChart'

import { isEmbedded } from './actionsReducers'

import './styles/Filterbar.css'

class FilterBar extends Component {
  constructor(props) {
    super(props)

    this.state = {
      sportsExpanded: false,
      filterExpanded: false,
      calendarExpanded: false,
      radiusExpanded: false,
      hasParams: !!window.location.search.substring(1),
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.state !== nextState) {
      return true
    } else {
      return this.props !== nextProps
    }
  }

  handleSportsClick = () => {
    let x = this.state.sportsExpanded
    this.setState({
      sportsExpanded: !x,
      filterExpanded: false,
      calendarExpanded: false,
      radiusExpanded: false,
    })
  }

  handleSportsSelected = () => {
    this.setState({
      sportsExpanded: false,
      filterExpanded: false,
      calendarExpanded: false,
      radiusExpanded: false,
    })
  }

  handleFilterClick = () => {
    let x = this.state.filterExpanded
    this.setState({
      sportsExpanded: false,
      filterExpanded: !x,
      calendarExpanded: false,
      radiusExpanded: false,
    })
  }

  handleCalendarClick = () => {
    let x = this.state.calendarExpanded
    this.setState({
      sportsExpanded: false,
      filterExpanded: false,
      calendarExpanded: !x,
      radiusExpanded: false,
    })
  }

  handleRadiusClick = () => {
    let x = this.state.radiusExpanded
    this.setState({
      sportsExpanded: false,
      filterExpanded: false,
      calendarExpanded: false,
      radiusExpanded: !x,
    })
  }

  render() {
    let sE = this.state.sportsExpanded
    let cE = this.state.calendarExpanded

    let iconSize = ''
    if (window.innerWidth <= 380) {
      iconSize = 20
    } else {
      iconSize = 25
    }
    return (
      <div className={ 'filterbar-con' + (isEmbedded() ? ' isEmbedded' : '') }>
        {
          !this.state.hasParams &&
          <PublicStateChart
            events={this.props.publicStateEvents}
            filter={this.props.publicStateFilter}
            onPublicState={this.props.onPublicState}
          />
        }
        <div className={sE ? 'filter-element fe-sports active' : 'filter-element fe-sports'} onClick={this.handleSportsClick}>
          <Icon name={this.props.sportsData} size={iconSize + 5} color={sE ? '#fff' : '#024781'} />
          <span className="filter-label visible">{this.props.sportsData}</span>
        </div>

        <div className={cE ? 'filter-element fe-cal active' : 'filter-element fe-cal'} onClick={this.handleCalendarClick}>
          <Icon name="calendar" size={iconSize} color={cE ? '#fff' : '#024781'} />
          <span className="filter-label visible">
            {moment(this.props.datepickerData).format('DD.MM.')} - {moment(this.props.datepickerDataUntil).format('DD.MM.')}
          </span>
        </div>

        {
          !!this.props.radiusData &&
          <div className="filter-element fe-rad" onClick={this.handleRadiusClick}>
            <Radius
              place={this.props.place} 
              setFiltersData={this.props.getFiltersData}
              radius={this.props.radiusData}
            />
          </div>
        }

        {
          !isEmbedded() &&
          <a href="/" target="_top" rel="noopener noreferrer" className="filter-element expanded-search">
            <span className="expanded-search-text">zurück zur Suche</span>
          </a>
        }

        {!sE ? null : (
          <div className="expanded-filter-con">
            <p>Sportart wählen: </p>
            <Sports onSelected={this.handleSportsSelected} setFiltersData={this.props.getFiltersData} d={this.props.sportsData} sendSportsData={this.props.getSportsData} />
          </div>
        )}
        {!cE ? null : (
          <div className="expanded-filter-con small">
            <p>Zeitraum wählen: </p>
            <Datepicker
              d={this.props.datepickerData}
              du={this.props.datepickerDataUntil}
              setFiltersData={this.props.getFiltersData}
              onSelected={this.handleSportsSelected}
            />
          </div>
        )}
      </div>
    )
  }
}

export default FilterBar



// WEBPACK FOOTER //
// ./src/components/FilterBar.js